// goals constants:
export const COMPLETED_GOAL = "COMPLETED_GOAL";
export const FAVOURITE_GOAL = "FAVOURITE_GOAL";
export const IN_PROGRESS_GOAL = "IN_PROGRESS_GOAL";
// goals actions:
export const ADD_GOAL = "ADD_GOAL";
export const EDIT_GOAL = "EDIT_GOAL";
